module.exports = __webpack_public_path__ + "media/images/shared/suppliers/ZF-d3a655639e2538e2897b5f2412110b99.jpg";